module.exports = __webpack_public_path__ + "static/img/xp-annual-card.1e66967c.png";